import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MainQuiz from "../../components/quiz/MainQuiz";
import { fetchIncompteteQuizById } from "../../redux/actions/quizzesActionCreators";

const IncompleteQuiz = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.quizzes.selected);
  const isAllowed = useSelector((state) => state.quizzes.isAllowed);
  const params = useParams();
  const orgaId = useSelector((state) => state.organizationProfile.id);
  const storedUser = localStorage.getItem("user");
  const accountType = JSON.parse(storedUser)?.account_type;
  

  useEffect(() => {
    if (accountType === "enterprise") {
      dispatch(fetchIncompteteQuizById(params.quizId, orgaId, accountType));
    } else {
      dispatch(fetchIncompteteQuizById(params.quizId));
    }
  }, [dispatch, params.quizId, orgaId, accountType]);

  return (
    <>
      {data ? (
        <MainQuiz
          data={data}
          isAllowed={isAllowed}
          initialPayload={data?.answers?.questions}
          initialThreshold={data?.answers?.usecases}
          pendingQuizz={true}
        />
      ) : null}
    </>
  );
};

export default IncompleteQuiz;
